// extracted by mini-css-extract-plugin
export default {"followBlock":"style_followBlock__nqX8D","counter":"style_counter__oOA1X","counter_columnMode":"style_counter_columnMode__PcR22"};